import styled from 'styled-components'

export const GradientLoadingContainer = styled.div<{ $scale?: number }>`
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`

export const ScalableWrapper = styled.div<{ $scale?: number }>`
  transform: ${({ $scale }) => ($scale ? `scale(${1 / $scale})` : 'none')};
  max-width: max-content;
  max-height: max-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`
